import React from 'react';
import { FormItem } from '@xbcb/form-item-components';
import { NamePath } from '@xbcb/ui-types';
import { useTheme } from 'styled-components';
import { StyledSelect } from './styles';

export interface CitationCodesProps {
  fullNamePath: NamePath;
  localNamePath: NamePath;
  label?: React.ReactNode;
  placeholder?: string;
  readOnly?: boolean;
  disabled?: boolean;
  maxLength?: number;
  required?: boolean;
}

// Dummy citation code options - will be replaced with lib-generated options later
const DUMMY_CITATION_OPTIONS = [
  { value: '1500.50', label: '1500.50', title: 'Simulating use' },
  { value: '1501', label: '1501', title: 'Small Objects' },
  { value: '1500.48', label: '1500.48', title: 'Age determination' },
  { value: '1500.44', label: '1500.44', title: 'Flammability test' },
  { value: '1278a', label: '1278a', title: "Lead in Children's products" },
  {
    value: '1500.91(d)(1)',
    label: '1500.91(d)(1)',
    title: 'Testing exclusion (d)(1)',
  },
  {
    value: '1500.91(d)(2)',
    label: '1500.91(d)(2)',
    title: 'Testing exclusion (d)(2)',
  },
  { value: '12878a', label: '12878a', title: "Lead in Children's products" },
];

const CitationCodes: React.FC<CitationCodesProps> = ({
  localNamePath,
  label = 'Citation Codes',
  placeholder = 'Select or type citation codes',
  readOnly = false,
  disabled = false,
  maxLength = 72,
  required = false,
}) => {
  const theme = useTheme();

  return (
    <FormItem
      name={localNamePath}
      label={label}
      $itemSize={theme.size.medium_large}
      $readOnly={readOnly}
      rules={[{ required }]}
      validateTrigger="onBlur"
    >
      <StyledSelect
        data-testid="citation-codes-select"
        mode="tags"
        labelInValue
        placeholder={placeholder}
        disabled={disabled || readOnly}
        options={DUMMY_CITATION_OPTIONS}
        tokenSeparators={[',']}
        maxTagTextLength={maxLength}
        showSearch
        optionFilterProp="label"
      />
    </FormItem>
  );
};

export default CitationCodes;
